import { ButtonProps } from "antd/lib/button";
import { IIconProps } from "../ZIcon/interface";

export interface IButtonProps extends ButtonProps {
	iconName?: string;
	iconPlacement?: "left" | "right";
	iconButton?: boolean; // use this when the button has only icon,
	iconSize?: "small" | "middle" | "large";
	iconProps?: IIconProps;
}

export enum EIconSizes {
	xlarge = "xl",
	large = "lg",
	middle = "md",
	small = "sm"
}
